import { AuthStore } from './AuthStore';
import { PluginStore } from './PluginStore';
import { ThemeStore } from './ThemeStore';

export class RootStore {
  authStore: AuthStore;
  pluginStore: PluginStore;
  themeStore: ThemeStore;

  constructor() {
    this.authStore = new AuthStore();
    this.pluginStore = new PluginStore();
    this.themeStore = new ThemeStore();
  }
}